export const config = {
  googleMapKey: process.env.REACT_APP_GOOGLE_MAP_API_KEY+process.env.REACT_APP_GOOGLE_MAP_API_2_KEY, 
};
